// extracted by mini-css-extract-plugin
export var finish = "style-module--finish--2ldd7";
export var finish_head = "style-module--finish_head--3j2ke";
export var finish_head_suptitle = "style-module--finish_head_suptitle--1qdZE";
export var finish_head_title = "style-module--finish_head_title--3CGIg";
export var finish_main = "style-module--finish_main--136wj";
export var finish_main_title = "style-module--finish_main_title--3kVuW";
export var finish_main_links = "style-module--finish_main_links--1ggkb";
export var finish_bot = "style-module--finish_bot--2rvNW";
export var finish_bot_title = "style-module--finish_bot_title--1gBjN";
export var finish_bot_desc = "style-module--finish_bot_desc--M8ORL";
export var largelink = "style-module--largelink--33u9b";
export var largelink_arrow = "style-module--largelink_arrow--3bImO";
export var largelink_l = "style-module--largelink_l--1_YJO";
export var largelink_r = "style-module--largelink_r--2SDHt";
export var largelink_title = "style-module--largelink_title--1U_Bh";